import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import base64 from "base-64";
import {
  errorAlertHandle,
  successAlertHandle,
} from "../../../../utils/utilFunctions";

export const getProcurement = createAsyncThunk(
  "app/getProcurement",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/proc/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const getProcurementByLimitApproval = createAsyncThunk(
  "app/getProcurementByLimitApproval",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/proc/limit-approval/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const getProcurementByPaymentApproval = createAsyncThunk(
  "app/getProcurementByPaymentApproval",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/proc/payment-approval/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const getProcurementByPayment = createAsyncThunk(
  "app/getProcurementByPayment",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/proc/payment/filter?start=${start}&limit=${limit}&type=bank`,
      body,
      config
    );
    return res.data;
  }
);

export const getProcurementByPaymentEcocash = createAsyncThunk(
  "app/getProcurementByPaymentEcocash",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/proc/payment/filter?start=${start}&limit=${limit}&type=ecocash`,
      body,
      config
    );
    return res.data;
  }
);

export const getProcurementByPaymentCash = createAsyncThunk(
  "app/getProcurementByPaymentCash",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/proc/payment/filter?start=${start}&limit=${limit}&type=cash`,
      body,
      config
    );
    return res.data;
  }
);

export const getProcurementByPaymentStatus = createAsyncThunk(
  "app/getProcurementByPaymentStatus",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/proc/payment-status/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const getProcurementByPaymentReconcile = createAsyncThunk(
  "app/getProcurementByPaymentReconcile",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/proc/payment-reconcile/filter?start=${start}&limit=${limit}&type=bank`,
      body,
      config
    );
    return res.data;
  }
);

export const getProcurementByPaymentReconcileEcocash = createAsyncThunk(
  "app/getProcurementByPaymentReconcileEcocash",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/proc/payment-reconcile/filter?start=${start}&limit=${limit}&type=ecocash`,
      body,
      config
    );
    return res.data;
  }
);

export const updateProcurementByLimitApproval = createAsyncThunk(
  "app/updateProcurementByLimitApproval",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ ...data, pin: base64.encode(data.pin) });
      const res = await axios.put(`/api/proc/limit-approval`, body, config);
      successAlertHandle("Action updated successfully", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const updateProcurementByPayment = createAsyncThunk(
  "app/updateProcurementByPayment",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ ...data, pin: base64.encode(data.pin) });
      const res = await axios.put(`/api/proc/payment`, body, config);
      successAlertHandle("Action updated successfully", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const updateProcurementByPaymentEcocash = createAsyncThunk(
  "app/updateProcurementByPaymentEcocash",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ ...data, pin: base64.encode(data.pin) });
      const res = await axios.put(`/api/proc/payment`, body, config);
      successAlertHandle("Action updated successfully", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const updateProcurementByPaymentCash = createAsyncThunk(
  "app/updateProcurementByPaymentCash",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ ...data, pin: base64.encode(data.pin) });
      const res = await axios.put(`/api/proc/payment`, body, config);
      successAlertHandle("Action updated successfully", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const updateProcurementByPaymentReconcile = createAsyncThunk(
  "app/updateProcurementByPaymentReconcile",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ ...data, pin: base64.encode(data.pin) });
      const res = await axios.put(`/api/proc/payment-reconcile`, body, config);
      successAlertHandle("Action updated successfully", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const updateProcurementByPaymentReconcileEcocash = createAsyncThunk(
  "app/updateProcurementByPaymentReconcileEcocash",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ ...data, pin: base64.encode(data.pin) });
      const res = await axios.put(`/api/proc/payment-reconcile`, body, config);
      successAlertHandle("Action updated successfully", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const updateProcurementByPaymentApproval = createAsyncThunk(
  "app/updateProcurementByPaymentApproval",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ ...data, pin: base64.encode(data.pin) });
      const res = await axios.put(`/api/proc/payment-approval`, body, config);
      successAlertHandle("Action updated successfully", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const getProcurementReport = createAsyncThunk(
  "app/getProcurementReport",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/report/proc/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const getProcurementByLimitApprovalReport = createAsyncThunk(
  "app/getProcurementByLimitApprovalReport",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/report/proc-limit-approval/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const getProcurementByPaymentApprovalReport = createAsyncThunk(
  "app/getProcurementByPaymentApprovalReport",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/report/proc-payment-approval/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const getProcurementByPaymentReport = createAsyncThunk(
  "app/getProcurementByPaymentReport",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/report/proc-payment/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const getProcurementByPaymentStatusReport = createAsyncThunk(
  "app/getProcurementByPaymentStatusReport",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/report/proc-payment-status/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const getProcurementByPaymentReconcileReport = createAsyncThunk(
  "app/getProcurementByPaymentReconcileReport",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/report/proc-payment-reconcile/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const getProcurementByPaymentSuccessReport = createAsyncThunk(
  "app/getProcurementByPaymentSuccessReport",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/report/proc-payment-success/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const getProcurementByPaymentSummaryReport = createAsyncThunk(
  "app/getProcurementByPaymentSummaryReport",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      //timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/report/proc-payment-summary/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const exportProcurementReport = async ({ filters, type, headerNames }) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const body = JSON.stringify({
      ...filters,
      headerNames, headerNames,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(`/api/download/${type}/filter`, body, config);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const triggerOtp = createAsyncThunk("app/otpProcurementByPayment", async ({loggedUser}) => {
  const res = await axios.get("/api/proc/payment-otp?loggedUser=" + loggedUser);
  return res.data;
});
